import { BaseService } from '@/services/base.service';
import { config } from '@/config';
import { IPreview, IResponse } from '@/interfaces/objects';

class PreviewService extends BaseService {
    private url: string = `${config.base_url}/api/previews`;
    public async preview(key1: string, key2: string): Promise<IResponse> {
        const url = `${this.url}/${key1}/${key2}`;
        return await this.get(url, 200);
    }
    public async getLatest(key: string, type: string): Promise<IResponse> {
        const url = `${this.url}/latest/${key}/${type}`;
        return await this.get(url, 200);
    }
    public async save(key: string, model: IPreview): Promise<IResponse> {
        const url = `${this.url}/save/${key}`;
        return await this.post(model, url, 200);
    }
}
export const previewService = new PreviewService();
